import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { displayModal } from "actions/shared-actions";
import ClosableModal from "components/source/shared/closable-modal";
import RtrButton from "components/design-system/rtr-button";
import RtrImage from "components/source/shared/rtr-image";
import { isActiveMembership as getIsActiveMembershipState } from "helpers/membership-helpers";
import { useFlagOrExperiment } from "components/source/hoc/with-flags-and-experiments";
import { getNotifyMeGTMLocalStorage, updateNotifyMeGTMLocalStorage } from "helpers/notify-me-helpers";

import { assetBaseUrls, flagsAndExperimentNames, NOTIFY_ME_GTM_IMAGE as GTM_IMAGE } from "rtr-constants";
import { MODAL_NAMES } from "rtr-constants/modalNames";

const GTMNotifyMeModal = () => {
  const dispatch = useDispatch();
  const [modalOpenFired, setModalOpenFired] = useState(false);
  const isMobileViewport = useSelector(state => state.browser?.isMobileViewport);
  const isActiveMembership = useSelector(({ membershipState }) => getIsActiveMembershipState(membershipState));
  const notifyMeLDFlag = useFlagOrExperiment(flagsAndExperimentNames.SF_SACT_250_NOTIFY_ME);
  const [hasSeenGTMModal, setHasSeenGTMModal] = useState(getNotifyMeGTMLocalStorage());
  const displayedModal = useSelector(state => state.displayedModal);

  useEffect(() => {
    if (isActiveMembership && notifyMeLDFlag && !hasSeenGTMModal && !modalOpenFired) {
      dispatch(displayModal(MODAL_NAMES.NOTIFY_ME_GTM));
      setModalOpenFired(true);
    }
  }, [isActiveMembership, notifyMeLDFlag, hasSeenGTMModal, modalOpenFired]);

  const handleClose = () => {
    dispatch(displayModal(false));
    updateNotifyMeGTMLocalStorage();
    setHasSeenGTMModal(true);
  };

  return (
    <ClosableModal
      isOpen={displayedModal === MODAL_NAMES.NOTIFY_ME_GTM}
      additionalStyles={{
        content: {
          height: isMobileViewport ? "100vh" : "auto",
          padding: "0 16px",
        },
      }}
      optionalWrapperClass="h-full lg:h-auto"
      onRequestClose={handleClose}>
      <div className="flex flex-col items-center justify-center h-full text-center">
        <div className="content-end my-4 grow lg:content-normal">
          <RtrImage
            src={`${assetBaseUrls.DESIGNER_IMAGES}/${isMobileViewport ? GTM_IMAGE.MOBILE : GTM_IMAGE.DESKTOP}`}
            className="w-[227px] lg:w-[324px]"
            alt="Notify Me"
          />
        </div>
        <h3 className="my-4">Use back in stock notifications</h3>
        <p className="text-lg">
          Get notified the second styles are available to rent by tapping Notify Me. Act fast—it&apos;s first come,
          first served!
        </p>
        <div className="content-end w-full grow lg:content-normal">
          <RtrButton className="mx-auto my-4 min-w-48" fullWidth={isMobileViewport} onClick={handleClose}>
            Got it
          </RtrButton>
        </div>
      </div>
    </ClosableModal>
  );
};

export default GTMNotifyMeModal;
